module.exports = __webpack_public_path__ + "img/icon-train.75edd6d8.svg";